export default __webpack_public_path__ + "static/media/Hot-Mop-Staircase-.159ff6b0.jpg";